/**
 * `/auth/change-password` — the one screen a session opened with a temporary
 * password can use. Outside the signed-in tree, so nothing else loads.
 */
import type { JSX } from "react";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { AuthLayout, ChangePasswordForm, useAuthBranding } from "@linkhr/auth/pages";
import { env } from "../env";

export const Route = createFileRoute("/auth/change-password")({
  beforeLoad: ({ context }) => {
    const snap = context.auth.getSnapshot();
    if (!snap.isAuthenticated) throw redirect({ to: "/login", replace: true });
    if (snap.mustChangePassword !== true) throw redirect({ to: "/", replace: true });
  },
  component: ChangePasswordRouteComponent,
});

function ChangePasswordRouteComponent(): JSX.Element {
  const navigate = useNavigate();
  const branding = useAuthBranding("", { passive: true });
  return (
    <AuthLayout branding={branding} product="accounting">
      <ChangePasswordForm
        apiBaseUrl={env.VITE_API_BASE_URL}
        onDone={() => void navigate({ to: "/", replace: true })}
      />
    </AuthLayout>
  );
}
